import { Modal, Card, Descriptions, Tag, Button } from "antd";
import React from "react";

function ViewInquiry({ visible, close, inquiryData }) {
  const inquiry = inquiryData?.inquiry;
  const userContext = inquiryData?.user_context;

  const getStatusColor = (status) => {
    switch (status) {
      case "new":
        return "orange";
      case "in_progress":
        return "blue";
      case "resolved":
        return "green";
      default:
        return "default";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Modal
      title="👁️ View Inquiry Details"
      open={visible}
      onCancel={() => close(false)}
      width={800}
      footer={[
        <Button key="close" onClick={() => close(false)}>
          Close
        </Button>,
      ]}
    >
      {/* Main Inquiry Details */}
      <Card
        title="📋 Inquiry Information"
        size="small"
        style={{ marginBottom: "16px" }}
      >
        <Descriptions column={2} size="small" bordered>
          <Descriptions.Item label="Inquiry ID">
            #{inquiry?.id}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={getStatusColor(inquiry?.status)}>
              {inquiry?.status?.toUpperCase()}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Name">{inquiry?.name}</Descriptions.Item>
          <Descriptions.Item label="Email">{inquiry?.email}</Descriptions.Item>
          <Descriptions.Item label="Phone">
            {inquiry?.phone || "Not provided"}
          </Descriptions.Item>
          <Descriptions.Item label="Created On">
            {formatDate(inquiry?.created_on)}
          </Descriptions.Item>
          <Descriptions.Item label="Subject" span={2}>
            <strong>{inquiry?.subject}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Message" span={2}>
            <div
              style={{
                maxHeight: "120px",
                overflowY: "auto",
                padding: "12px",
                background: "#f8f9fa",
                borderRadius: "6px",
                fontSize: "14px",
                lineHeight: "1.5",
                border: "1px solid #e8e8e8",
              }}
            >
              {inquiry?.message}
            </div>
          </Descriptions.Item>
          {inquiry?.updated_on &&
            inquiry?.updated_on !== inquiry?.created_on && (
              <Descriptions.Item label="Last Updated" span={2}>
                {formatDate(inquiry?.updated_on)}
              </Descriptions.Item>
            )}
        </Descriptions>
      </Card>

      {/* Admin Response (if exists) */}
      {inquiry?.admin_response && (
        <Card
          title="💬 Admin Response"
          size="small"
          style={{ marginBottom: "16px" }}
        >
          <div
            style={{
              padding: "12px",
              background: "#f0f9ff",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "1.6",
              border: "1px solid #bfdbfe",
            }}
          >
            {inquiry.admin_response}
          </div>
        </Card>
      )}

      {/* User Context (if user is registered) */}
      {userContext && (
        <Card
          title="👤 User Account Information"
          size="small"
          style={{ marginBottom: "16px" }}
        >
          <Descriptions column={2} size="small" bordered>
            <Descriptions.Item label="User ID">
              #{userContext.id}
            </Descriptions.Item>
            <Descriptions.Item label="Registration Date">
              {formatDate(userContext.created_on)}
            </Descriptions.Item>
            <Descriptions.Item label="Full Name">
              {userContext.first_name} {userContext.last_name}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {userContext.phone || "Not provided"}
            </Descriptions.Item>
          </Descriptions>
          <div
            style={{
              marginTop: "8px",
              padding: "8px",
              background: "#f6ffed",
              borderRadius: "4px",
              fontSize: "12px",
              color: "#52c41a",
              border: "1px solid #b7eb8f",
            }}
          >
            ✅ This user has a registered account in the system
          </div>
        </Card>
      )}

      {/* Quick Actions Info */}
      <div
        style={{
          padding: "12px",
          background: "#fffbf0",
          borderRadius: "6px",
          fontSize: "13px",
          color: "#d46b08",
          marginTop: "16px",
          border: "1px solid #ffd591",
        }}
      >
        💡 <strong>Quick Actions:</strong> You can respond to this inquiry or
        update its status from the main table.
      </div>
    </Modal>
  );
}

export default ViewInquiry;
